import { useEffect, useState } from 'react';
import {
    DataGrid, GridToolbarContainer, gridPageCountSelector,
    gridPageSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';
import { localDatabaseUrls } from "../../backend/constants";
import classess from './SVCManageHistoryTable.module.css';
import { Button, Tooltip, TextField, Dialog, DialogActions } from "@mui/material";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { format } from 'date-fns';
import { svcDownloadFile } from '../../API/svcDownloadFile.Api';
import SvcFilters from './SVCFilters';




const SVCManageHistoryTable = ({ uploadHistory, isPaginationRequired }) => {

    const [gridData, setGridData] = useState(uploadHistory);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    useEffect(() => {





        if (uploadHistory && uploadHistory.length > 0) {
            uploadHistory.map((item) => {
                item.download = item.status === errorStatus ? 'y' : 'n'
                return item.uploadedDate
            })
            setGridData(uploadHistory);
            setLoading(false);
        }else{
             setLoading(false);
        }
    }, [uploadHistory])

    const errorStatus = "Processed with errors";
    const originalStatus = ["Uploaded", "In progress"];
    const handleReset = () => {
        window.location.reload();
    }
    const handleFilterOpen = () => setOpen(true);
    const handleFilterClose = () => setOpen(false);
     const handleFilterApply = (filterdValues) => {
        try {
            handleFilterClose();
            if (filterdValues) {
                setGridData(filterdValues)
            }

        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Button
                    variant="contained"
                    className={classess.filterBtn}
                    onClick={handleFilterOpen}
                >
                    <FilterAltIcon fontSize="medium" />
                </Button>
                <Button
                    variant="contained"
                    className={classess.resetBtn}
                    onClick={handleReset}
                >
                    Reset
                </Button>
                <Dialog
                                    open={open}
                                    onClose={handleFilterClose}
                                    maxWidth="lg"
                                    PaperProps={{
                                        sx: {
                                            borderRadius: 2,
                                            p: 1,
                                            overflow: 'visible'
                                        }
                                    }}
                                    disableEnforceFocus
                                >
                
                                    <SvcFilters
                                        // dataValues={gridData}
                                        callBack={(formValues) => handleFilterApply(formValues)}
                                        closeCallBack={handleFilterClose} />
                                    <DialogActions>
                                        <Button onClick={handleFilterClose}>Cancel</Button>
                                        {/* <Button onClick={handleFilterApply} variant="contained">Apply</Button> */}
                                    </DialogActions>
                                </Dialog>
            </GridToolbarContainer>
        )
    }

    // function getCategoryLabel(category) {
    //     return COST_TYPE_OPTIONS.find(
    //         option => option.value === category?.toLowerCase()
    //     )?.label ?? "";
    // }

    function rowProcess(validRows, totalRows) {
        return totalRows !== null && validRows !== null ? validRows + '/' + totalRows : '0/0';

    }
    function CustomPagination() {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);

        return (
            isPaginationRequired ? <Pagination
                color="primary"
                count={pageCount}
                page={page + 1}
                onChange={(event, value) => apiRef.current.setPage(value - 1)}
            /> : null
        );
    }

    // const handleDownload = async (fileId, fileName, downloadFile) => {
    //     try {
    //         await downloadErrorReport(fileId, fileName, downloadFile);

    //     } catch (error) {
    //         console.error('Error downloading the file:', error);
    //     }
    // };
  const handleDownload = async (fileId, fileName, downloadFile) => {
          try {
              await svcDownloadFile(fileId, fileName, downloadFile);
  
          } catch (error) {
              console.error('Error downloading the file:', error);
          }
      };

    useEffect(() => {



    }, [])
    const CustomDateFilterInput = (props) => {
        const { item, applyValue } = props;
        const [selectedDate, setSelectedDate] = useState(item.value ? new Date(item.value) : null);

        const handleChange = (newDate) => {
            const formattedDate = newDate ? format(newDate, 'yyyy-MM-dd') : null;
            setSelectedDate(newDate);
            applyValue({ ...item, value: formattedDate });
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    label="Select Date"
                    value={selectedDate}
                    onChange={(newDate) => handleChange(newDate)}
                    views={['year', 'month', 'day']}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                />
            </LocalizationProvider>
        );
    };


    const CustomDateRangeFilterInput = (props) => {
        const { item, applyValue } = props;
        const [selectedDateRangeFrom, setSelectedDateRangeFrom] = useState(item.value?.from ? new Date(item.value.from) : null);
        const [selectedDateRangeTo, setSelectedDateRangeTo] = useState(item.value?.to ? new Date(item.value.to) : null);

        const handleChange = (newFrom, newTo) => {
            if (newFrom || newTo) {
                applyValue({
                    ...item,
                    value: {
                        from: newFrom ? format(newFrom, 'yyyy-MM-dd') : null,
                        to: newTo ? format(newTo, 'yyyy-MM-dd') : null
                    }
                });
            }
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <DatePicker
                        label="From Date"
                        value={selectedDateRangeFrom}
                        onChange={(newDate) => {
                            setSelectedDateRangeFrom(newDate);
                            handleChange(newDate, selectedDateRangeTo);
                        }}
                        views={['year', 'month', 'day']}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                    <DatePicker
                        label="To Date"
                        value={selectedDateRangeTo}
                        onChange={(newDate) => {
                            setSelectedDateRangeTo(newDate);
                            handleChange(selectedDateRangeFrom, newDate);
                        }}
                        views={['year', 'month', 'day']}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                </div>
            </LocalizationProvider>
        );
    };



    const columns =
        [
            // {
            //     field: 'fileName', flex: 1, headerName: 'File Name-2', sortable: true, filterable: true, width: 200,
            //     renderCell: (params) => {
            //         return (originalStatus.includes(params.row.status) ?
            //             params.row.fileName :
            //             (<Tooltip title={params.row.fileName}>
            //                 <Button style={{ overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '150px', textOverflow: 'ellipsis', display: 'inline-block' }}
            //                     onClick={() => handleDownload(params.row.id, params.row.fileName, localDatabaseUrls.serviceURL.originalFilePrefix)}>
            //                     {params.row.fileName}
            //                 </Button>
            //             </Tooltip>
            //             )
            //         )

            //     },
            // },
            {
                field: 'fileName',
                headerName: 'File Name',
                flex: 1,
                sortable: true,
                filterable: true,
                width: 200,
                valueGetter: (params) => params.row.fileName, // ensures filtering uses the fileName value
                renderCell: (params) => {
                    return (
                        originalStatus.includes(params.row.status)
                            ? params.row.fileName
                            : (
                                <Tooltip title={params.row.fileName}>
                                    <Button
                                        style={{
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            maxWidth: '150px',
                                            textOverflow: 'ellipsis',
                                            display: 'inline-block'
                                        }}
                                        onClick={() =>
                                            handleDownload(
                                                params.row.uuid,
                                                params.row.fileName,
                                                localDatabaseUrls.serviceURL.originalFilePrefixSvc
                                            )
                                        }
                                    >
                                        {params.row.fileName}
                                    </Button>
                                </Tooltip>
                            )
                    );
                }
            },
            {
                field: 'uploadedBy',
                flex: 1,
                headerName: 'Uploaded By',
                sortable: true,
                filterable: true,
                width: 200,

            },
            {
                field: 'uploadedDate', flex: 1, headerName: 'Uploaded Date', sortable: true, filterable: true, width: 200,


                filterOperators:
                    [
                        {
                            label: 'is',
                            value: 'is',
                            getApplyFilterFn: (filterItem) => {
                                if (!filterItem.columnField || !filterItem.value) {
                                    return null;
                                }
                                const filterDate = new Date(filterItem.value);
                                return ({ value }) => {
                                    const cellDate = new Date(value);
                                    return (cellDate.getFullYear() === filterDate.getFullYear() && cellDate.getMonth() ===
                                        filterDate.getMonth() && cellDate.getDate() === filterDate.getDate())
                                }
                            },
                            InputComponent: CustomDateFilterInput
                        },

                        {
                            label: 'is after',
                            value: 'is after',
                            getApplyFilterFn: (filterItem) => {
                                if (!filterItem.columnField || !filterItem.value) {
                                    return null;
                                }
                                return ({ value }) => new Date(value) > new Date(filterItem.value);
                            },
                            InputComponent: CustomDateFilterInput
                        },
                        {
                            label: 'is before',
                            value: 'is before',
                            getApplyFilterFn: (filterItem) => {
                                if (!filterItem.columnField || !filterItem.value) {
                                    return null;
                                }
                                return ({ value }) => new Date(value) < new Date(filterItem.value);
                            },
                            InputComponent: CustomDateFilterInput
                        },
                        {
                            label: 'date range',
                            value: 'date range',
                            getApplyFilterFn: (filterItem) => {
                                if (!filterItem.columnField || !filterItem.value) {
                                    return null;
                                }

                                const { from, to } = filterItem.value;
                                const fromDate = from ? new Date(from) : null;
                                const toDate = to ? new Date(to) : null;

                                return ({ value }) => {
                                    const cellDate = new Date(value);
                                    if (fromDate && toDate) {
                                        return cellDate >= fromDate && cellDate <= toDate;
                                    }
                                    if (fromDate) return cellDate >= fromDate;
                                    if (toDate) return cellDate <= toDate;
                                    return true;
                                };
                            },
                            InputComponent: CustomDateRangeFilterInput
                        }
                    ]
            },
            {
                field: 'category', flex: 1, headerName: 'Category', sortable: true, filterable: true, width: 200,
            },
            {
                field: 'costType', flex: 1, headerName: 'APG/ASG', sortable: true, filterable: true, width: 200,
            },
            
            {
                field: 'status', flex: 1, headerName: 'Status', sortable: true, filterable: true, width: 200,
            },
            {
                field: 'rows', flex: 1, headerName: 'Rows (Valid/Total)', sortable: true, filterable: true, width: 100,
                valueGetter: (params) => rowProcess(params.row.validRows, params.row.totalRows),
            },
            {
                field: 'download', flex: 1, headerName: 'Download report', sortable: true,
                disableColumnMenu: true, width: 200,
                renderCell: (params) => (
                    params.row.status === errorStatus && 
                    (
                        <Button className={classess.uploadBtn}
                            onClick={() => handleDownload(params.row.uuid, params.row.fileName, localDatabaseUrls.serviceURL.errorFileSvc)}>
                            Download
                        </Button>
                    )
                ),

            }
        ]
   return (
      <div
         style={{
            height: 'calc(100vh - 230px)',
            width: '100%',
            minWidth: 0,
            maxWidth: '100vw',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            background: '#fff'
         }}
      >
         <div style={{ flex: 1, overflow: 'visible' }}>
            <DataGrid
               components={{
                  Toolbar: CustomToolbar,
                  Pagination: CustomPagination,
               }}
               rows={gridData }
               columns={columns}
                getRowId={(row) => row.uuid}
               disableRowSelectionOnClick
               pagination
               pageSize={10}
               autoHeight={false}
               sortingMode="client"
               filterMode="client"
               loading={loading}
               sx={{
                  width: '100%',
                  minWidth: 0,
                  maxWidth: '100vw',
                  '& .MuiDataGrid-columnHeaderTitle': {
                     fontWeight: 'bold',
                  },
                  '& .MuiDataGrid-toolbarcontainer': {
                     display: 'flex',
                     justifyContent: 'space-between',
                  },
                  '& .MuiDataGrid-cellContent': {
                     whiteSpace: 'nowrap',
                     overflow: 'hidden',
                     textOverflow: 'ellipsis',
                  },
                  '& .MuiTablePagination-root': {
                     width: '100%',
                     minWidth: 0,
                     maxWidth: '100vw',
                  },
                  '& .MuiDataGrid-footerContainer': {
                     width: '100%',
                     minWidth: 0,
                     maxWidth: '100vw',
                  }
               }}
            />
         </div>
      </div>
   );
}

export default SVCManageHistoryTable;